export default __webpack_public_path__ + "static/media/mastercard.92bfa8d0.png";